import useJsonApi from "lib/useJsonApi.js";

function useUpcomingSessions() {
  return useJsonApi({
    url: `/api/session/upcoming`,
  });
}

export default useUpcomingSessions;
